import React, { Component } from 'react';
import { Modal, Input } from 'antd';
import { Row, Col } from 'react-flexbox-grid';
import ProfileStep from 'components/assumptions/profiles/ProfileStep';
import ProfileSettingStepBar from 'components/assumptions/ProfileSettingStepBar';
import PainPointsForm from 'components/assumptions/profiles/PainPointsForm';
import OTextArea from 'components/commons/OTextArea';
import { Card, Button, Icon } from 'antd';

class PersonaInfoForm extends Component {

    constructor(props) {
        super(props);
        this.translate = props.translate;
        this.state = {
            persona: props.persona,
            isAvatarOpened: false,
            mounted: false,
        };
    }

    componentDidMount() {
        this.setState({ mounted: true });
    }

    render() {
        const t = this.translate;
        return (
            <Modal
                title={t('assumption.personal.title')}
                visible={this.state.visible}
                onOk={this.hideModal.bind(this)}
                onCancel={this.hideModal.bind(this)}
                width="80%"
                footer={null}
            >
                <ProfileSettingStepBar>
                    <ProfileStep title={t('assumption.personal.profile.title')} persona={this.state.persona} onUpdate={this.onUpdate.bind(this)} />
                    <Col title={t('assumption.personal.problem.title')} xs={12}>
                        <PainPointsForm persona={this.state.persona} onUpdate={this.onUpdate.bind(this)} />
                    </Col>
                    <OTextArea
                        onUpdate={this.onUpdate.bind(this)}
                        title={t('assumption.personal.trigger.title')}
                        container={this.state.persona}
                        fieldName='salesCanvas.trigger'
                        label={t('assumption.personal.trigger.question')}/>
                    <OTextArea
                        onUpdate={this.onUpdate.bind(this)}
                        title={t('assumption.personal.action.title')}
                        container={this.state.persona}
                        fieldName='salesCanvas.action'
                        label={t('assumption.personal.action.question')}/>
                    <OTextArea
                        onUpdate={this.onUpdate.bind(this)}
                        title={t('assumption.personal.conversation.title')}
                        container={this.state.persona}
                        fieldName='salesCanvas.conversation'
                        label={t('assumption.personal.conversation.question')}/>
                    <Col title={t('assumption.personal.sell.title')} xs={12}>
                        <Row>
                            <Col xs="12">
                                <OTextArea
                                    onUpdate={this.onUpdate.bind(this)}
                                    title={t('assumption.personal.sell.title')}
                                    container={this.state.persona}
                                    fieldName='salesCanvas.sell'
                                    label={t('assumption.personal.sell.question')}/>
                            </Col>
                        </Row>
                        <Row center="xs" className="step-bar-controls">
                            <Button type="primary" size="lg" onClick={() => this.done()}>{t('done')}</Button>
                        </Row>
                    </Col>
                </ProfileSettingStepBar>
            </Modal>
        );
    }

    done() {
        this.hideModal();
    }

    hideModal() {
        this.onUpdate(this.state.persona);
        this.setState({ visible: false }, () => console.log("closed"));
    }

    showModal() {
        this.setState({ visible: true }, () => console.log("opened"));
    }

    onUpdate(persona) {
        if (this.props.onUpdate) {
            this.props.onUpdate(persona);
        }
        this.setState({ persona });
    }
}

export default PersonaInfoForm;


// WEBPACK FOOTER //
// ./src/components/assumptions/personas/PersonaInfoForm.js